let productQuantities = {}; // Global variable to store product quantities


window.addEventListener('DOMContentLoaded', (event) => {
  // Detect if the cart drawer is activated
  if (!document.querySelector('cart-drawer')) {
    console.error('EG Cart Upsell: The cart drawer is not activated');
    return;
  }


  // Init Cart Upsell feature
  const initCartUpsell = async (preload = false) => {
    const element = document.querySelector('#eg-cart-upsell');
    const cartDrawerItems = document.querySelector('cart-drawer-items');


    if (element && !cartDrawerItems.classList.contains('is-empty')) {
      document.querySelector('#CartDrawer #eg-cart-upsell')?.remove();
      cartDrawerItems.insertAdjacentElement('beforeend', element.cloneNode(true));
      document.querySelector('#CartDrawer #eg-cart-upsell').style.display = 'block';


      if (preload) {
        document.querySelector('#CartDrawer #eg-cart-upsell').style.opacity = '0.2';
      }


      // Set the first radio button as default selected for all swatch-elements
      document.querySelectorAll('.swatch-element.custom').forEach((swatchElement) => {
        const firstRadio = swatchElement.querySelector('input[type="radio"]');
        if (firstRadio) {
          firstRadio.checked = true;
          const productId = firstRadio.dataset.productId;
          productQuantities[productId] = 1; // Set default quantity to 1
        }
      });


      document.querySelectorAll('#CartDrawer #eg-cart-upsell input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          document.querySelector('#CartDrawer-CartErrors').style.display = 'none';


          const variantImage = radio.dataset.variantImage;
          const variantPrice = radio.dataset.variantPrice;
          const variantTitle = radio.dataset.variantTitle;
          const productId = radio.dataset.productId;


          if (variantImage.length) {
            radio.closest('.eg-cart-upsell-list-item').querySelector('img').setAttribute('src', variantImage);
          }


          radio.closest('.eg-cart-upsell-list-item').querySelector('.cart-item__price').textContent = variantPrice;
          radio.closest('.eg-cart-upsell-list-item').querySelector('.cart-item__name').textContent = variantTitle;


          // Update product quantity in global variable
          productQuantities[productId] = 1; // Default quantity is 1


          // Update quantity input value
          document.querySelector('#CartDrawer .quantity__input').value = productQuantities[productId];
        });
      });


      // Event delegation to handle button clicks within the container
      document.querySelector('#CartDrawer #eg-cart-upsell').addEventListener('click', async (event) => {
        const btn = event.target.closest('.upsell-btn');
        if (!btn) return; // If the clicked element is not a button with the specified class, exit


        event.preventDefault();


        btn.classList.add('loading');
        btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');


        const selectedRadio = btn.closest('.eg-cart-upsell-list-item').querySelector('input[type="radio"]:checked');
        const variantId = selectedRadio ? selectedRadio.dataset.variantId : null;


        if (variantId) {
          // Adding item to cart
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: productQuantities[variantId] || 1, // Use stored quantity or default to 1
            }),
          });


          if (!addResponse.ok) {
            console.error('Error adding item to cart:', addResponse.statusText);
            return;
          }


          // Update product quantity in global variable
          productQuantities[variantId] = productQuantities[variantId] ? productQuantities[variantId] + 1 : 1;


          // Update quantity input value
          document.querySelector('#CartDrawer .quantity__input').value = productQuantities[variantId];
         
          document
            .querySelector('#CartDrawer [name="updates[]"]')
            .dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          console.error('No variant selected');
        }
      });
    }
  };
  initCartUpsell();


  // Load cart goal feature dynamically
  const loadAjaxContent = async () => {
    const response = await fetch(window.location.href);
    const data = await response.text();
    const newDocument = new DOMParser().parseFromString(data, 'text/html');


    const newCartUpsell = newDocument.querySelector('#eg-cart-upsell');
    if (newCartUpsell) {
      document.querySelector('#CartDrawer #eg-cart-upsell')?.remove();
      document.querySelector('cart-drawer-items').insertAdjacentElement('beforeend', newCartUpsell);


      // Re-initialize Cart Upsell feature
      initCartUpsell();
    }
  };


  // Listen to ajax changes in the drawer (through class change)
  const listenDrawerAjax = async () => {
    const onMutation = async (mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const addedNode of mutation.addedNodes) {
            if (addedNode.classList?.contains('drawer__inner') || addedNode.classList?.contains('drawer__header')) {
              initCartUpsell(true);
              await loadAjaxContent();
              initCartUpsell(false);
            }
          }
        }
      }
    };


    new MutationObserver(onMutation).observe(document.querySelector('#CartDrawer'), {
      childList: true,
      subtree: true,
    });
  };
  listenDrawerAjax();
});


$(document).ready(function () {
  console.debug(`Slick initializing`, $('#eg-cart-upsell-list'))


  $('#eg-cart-upsell-list').slick({
    slidesToShow: 3, // Adjust the number of slides to show
    slidesToScroll: 1,
    prevArrow: $('.n-prev-arrow'), // Previous arrow button selector
    nextArrow: $('.n-next-arrow'), // Next arrow button selector
    responsive: [
      {
        breakpoint: 768,
        settings: {
         infinite: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          slidesToShow: 1,
        },
      },
    ],
  });
});



